import { useQuery } from '@tanstack/react-query';
import { getInfrastructureChartData } from 'services/reactQueryservices';
import { infrastructureKey } from 'react_query/query-keys';

const useInfrastructureChart = (project: string) => {
    console.log('projectaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', project);
    const { data, isFetching, error } = useQuery({
        queryKey: [infrastructureKey,project],
        queryFn: () => getInfrastructureChartData(project)
    });

    return {
        data,
        isFetching,
        error
    };
}

export default useInfrastructureChart